import { useEffect, useState } from 'react';
import { NotFound } from '../../../components/NotFound';
import { useAuth } from '../../../contexts/AuthProvider';
import { formatDate, numberDisplay, parseFixed } from '../../../services/formats';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import { useUtility } from '../../../contexts/UtilityContext';
import { fetchRptItemPoPiBalance, markPurchaseOrderClose, RptItemOrderRecdCombinedModel } from '../../../model/purchase-order.model';
import Badge from '../../../components/Badge';

interface IOwnProps {
  id?: number;
}

export default function ItemPurchaseOrderBalance({ id }: IOwnProps) {
  const { isLoading, showLoader, hideLoader } = useUtility();
  const [balanceList, setBalanceList] = useState<Array<RptItemOrderRecdCombinedModel>>([]);
  const [filteredList, setFilteredList] = useState<Array<RptItemOrderRecdCombinedModel>>([]);
  const { authInfo } = useAuth();

  useEffect(() => {
    async function fetchData() {
      if (id) {
        try {
          showLoader();
          const data = await fetchRptItemPoPiBalance(id, authInfo);
          data.forEach((value, idx) => {
            let balance = value.order.qty;
            value.recd.forEach((item) => {
              balance -= parseFixed(item.qty);
              item.balance_qty = balance;
            });

            setBalanceList((prev) => ([
              ...prev,
              value,
            ]));

            setFilteredList((prev) => ([
              ...prev,
              value,
            ]));
          });
        } catch (err) {
          alert(err);
        } finally {
          hideLoader();
        }
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authInfo, id]);

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const keyword = e.target.value.toLowerCase();
    const filtered = balanceList.filter(item => item.order.ac_name.toLowerCase().includes(keyword));
    setFilteredList(filtered);
  };

  const markOrderClose = async (id: number, idx: number) => {
    try {
      showLoader();
      await markPurchaseOrderClose(id, authInfo);
      balanceList[idx].order.closed_status = 'Y';
      setBalanceList([...balanceList]);
      setFilteredList([...balanceList]);
    } catch (err) {
      alert(err);
    } finally {
      hideLoader();
    }
  };

  return (
    <>
      {!isLoading && !balanceList.length ? <NotFound /> : <>
        <Form.Group className="mb-3" controlId="itemSearch">
          <Form.Control
            type="text"
            placeholder="Search by Party Name..."
            onChange={handleFilterChange}
          />
        </Form.Group>
        {filteredList.map((list, idx) => (
          <Table bordered responsive width="100%" key={`group-fragment-${idx}`}>
            <thead>
              <tr>
                <td colSpan={4} className='bg-dark-subtle'>
                  <Container fluid>
                    <Row>
                      <Col className="text-center"><strong>ORDER#</strong><br />{list.order.v_no}</Col>
                      <Col className="text-center"><strong>DATED</strong><br />{formatDate(list.order.v_date)}</Col>
                      <Col className="text-center"><strong>PARTY</strong><br />{list.order.ac_name}</Col>
                      <Col className="text-center"><strong>QNTY<br /></strong>{numberDisplay(list.order.qty)}</Col>
                      <Col className="text-center"><strong>Delivery</strong><br />{list.order.delivery}</Col>
                      <Col className="text-center">
                        {list.order.closed_status !== 'Y' ? (
                          <Button size='sm' variant='danger' onClick={() => markOrderClose(list.order.id, idx)}>Mark as Closed</Button>
                        ) : <><strong>Status</strong><br /><Badge badge color="primary" text='Closed' /></>}
                      </Col>
                    </Row>
                  </Container>
                </td>
              </tr>
              <tr>
                <th className='text-center'>NO</th>
                <th className='text-center'>DATED</th>
                <th className='text-end'>RECD</th>
                <th className='text-end'>BALANCE</th>
              </tr>
            </thead>
            <tbody>
              {list.recd.length > 0 ? <>{list.recd.map((item, index) => (
                <tr key={`account-ledger-${index}`}>
                  <td className='text-center'>{item.v_no}</td>
                  <td className='text-center'>{formatDate(item.v_date)}</td>
                  <td className='text-end'>{numberDisplay(item.qty)}</td>
                  <td className='text-end'>{numberDisplay(item.balance_qty)}</td>
                </tr>
              ))}
                <tr>
                  <th className='text-end' colSpan={2}>SUB TOTAL</th>
                  <th className='text-end'>{numberDisplay(list.order.recd_qty)}</th>
                  <th className='text-end'>{numberDisplay(parseFixed(list.order.qty, 3) - parseFixed(list.order.recd_qty, 3))}</th>
                </tr>
              </> : (<tr>
                <td colSpan={4} className='bg-warning-subtle text-center'>No Received yet!</td>
              </tr>
              )}
            </tbody>
          </Table>
        ))}
      </>
      }
    </>
  );
};